import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";
import { CreditCard, Loader2 } from "lucide-react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const Fee = ({ f }) => {
  const [busy, setBusy] = useState(false);
  const pay = async () => {
    setBusy(true);
    try { const { data } = await api.post(`/rt/fees/${f.id}/checkout`, { origin_url: window.location.origin }); window.location.href = data.checkout_url; }
    catch (e) { toast.error(apiError(e)); setBusy(false); }
  };
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-t border-slate-100 py-3 text-sm" data-testid={`rt-fee-${f.id}`}>
      <div><div className="font-semibold text-slate-900">{f.site_name} application fee</div>
        <div className="text-xs text-slate-500">{new Date(f.created_at).toLocaleDateString()}{f.status !== "due" && f.paid_at ? ` · paid ${new Date(f.paid_at).toLocaleDateString()}` : ""}</div></div>
      <div className="flex items-center gap-3">
        <span className="font-display text-lg font-bold text-slate-900" data-testid={`rt-fee-amount-${f.id}`}>${f.amount.toFixed(2)}</span>
        {f.status === "due" ? <Button onClick={pay} disabled={busy} className="gold-cta border-0 font-bold" data-testid={`rt-fee-pay-${f.id}`}>
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <><CreditCard className="mr-2 h-4 w-4" />Pay</>}</Button>
          : <Badge className="border-0 bg-emerald-50 text-emerald-800" data-testid={`rt-fee-status-${f.id}`}>Paid</Badge>}
      </div>
    </div>
  );
};

export default function RtPayments() {
  const { user } = useAuth();
  const [fees, setFees] = useState(null);
  useEffect(() => { if (user?.role !== "property_manager") { api.get("/rt/fees").then((r) => setFees(r.data)).catch((e) => { setFees([]); toast.error(apiError(e)); }); } }, [user]);
  if (user?.role === "property_manager") return <Navigate to="/pm" replace />;
  const due = (fees || []).filter((f) => f.status === "due").reduce((s, f) => s + f.amount, 0);
  return (
    <div className="mx-auto max-w-4xl" data-testid="rt-payments-page">
      <h1 className="font-display text-3xl font-extrabold text-slate-900">Payments</h1>
      <p className="mb-5 text-sm text-slate-600">Fees some REO websites charge to apply. Once you pay, Ava finishes the application.</p>
      <Card className="p-6">
        <div className="mb-2 text-sm text-slate-600" data-testid="rt-payments-due">Amount due: <b className="text-slate-900">${due.toFixed(2)}</b></div>
        {fees === null ? <p className="text-sm text-slate-400">Loading...</p> : fees.length ? fees.map((f) => <Fee key={f.id} f={f} />)
          : <p className="py-6 text-center text-sm text-slate-500" data-testid="rt-payments-empty">No fees yet.</p>}
      </Card>
    </div>
  );
}
